import { createFileRoute } from '@tanstack/react-router'
import { useNavigate, useSelector } from '@ufc/core'
import { useEffect } from 'react'
import { selectIsAdmin } from '@ufc/domains/admin-context'
import { KioskWeighbridgeSection } from '@ufc/domains/shipments'

export const Route = createFileRoute('/weighbridge')({
  component: WeighbridgePage,
})

function WeighbridgePage() {
  const isAdmin = useSelector(selectIsAdmin)
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAdmin) {
      navigate({ to: '/scan' })
    }
  }, [isAdmin, navigate])

  if (!isAdmin) return null

  return <KioskWeighbridgeSection />
}
